<template>
  <div class="summary">
    <div class="panels form-section">
      <div class="panel-left-flex panel-left-gap">
        <h4>Requirements</h4>
        <div class="form-section">
          <div class="checkboxlabel" :class="{ on: isCheckedBags === true }" @click="isCheckedBags = !isCheckedBags">
            <div class="checkbox" />
            <label>Will you check a bag?</label>
          </div>
        </div>
        <div class="form-section">
          <label>Must you fly at specific times?</label>
          <textarea v-model="times" placeholder="Optional" />
        </div>
        <div class="form-section">
          <label>Any other flight requirements?</label>
          <textarea v-model="other" placeholder="Optional" />
        </div>
      </div>
      <div class="panel-right-flex panel-right-gap">
        <h4>Summary</h4>
        <FlightItineraryAssist :flights="flights" />
      </div>
    </div>
    <div id="navigation">
      <button @click="next">Next Step</button>
      <a @click="back">Back</a>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";

import FlightItineraryAssist from "./TripNewBookSummaryFlightAssist.vue";

const emit = defineEmits(["complete", "scroll", "update:isSavedRoute", "update:flightsOther"]);
defineProps(["flights"]);

const isCheckedBags = ref(false);
const times = ref(null);
const other = ref(null);
const otherFormatted = computed(() => {
  var desc = "Checked Bags: " + (isCheckedBags.value ? "Yes" : "No") + "\n";
  desc += "Times: " + (times.value ? times.value : "NA") + "\n";
  desc += "Other: " + (other.value ? other.value : "NA");
  return desc;
});

const back = () => {
  emit("update:isSavedRoute", false);
};

const next = () => {
  emit("update:flightsOther", otherFormatted.value);
  emit("complete");
  emit("scroll");
};
</script>
